import api from './api'

export async function getCart() {
  const { data } = await api.get('/cart')
  return data
}

export async function mergeCart() {
  const { data } = await api.post('/cart/merge')
  return data
}

export async function addToCart(item) {
  const { data } = await api.post('/cart/items', item)
  return data
}

export async function updateCartItem(itemId, quantity) {
  const { data } = await api.put(`/cart/items/${itemId}`, { quantity })
  return data
}

export async function removeCartItem(itemId) {
  const { data } = await api.delete(`/cart/items/${itemId}`)
  return data
}

export async function clearCart() {
  const { data } = await api.delete('/cart')
  return data
}

export async function applyCoupon(code) {
  const { data } = await api.post('/cart/coupon', { code })
  return data
}

export async function removeCoupon() {
  const { data } = await api.delete('/cart/coupon')
  return data
}
